import { render, staticRenderFns } from "./GoodsSliderPreview.vue?vue&type=template&id=ee22749a&scoped=true"
import script from "./GoodsSliderPreview.vue?vue&type=script&lang=js"
export * from "./GoodsSliderPreview.vue?vue&type=script&lang=js"
import style0 from "./GoodsSliderPreview.vue?vue&type=style&index=0&id=ee22749a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee22749a",
  null
  
)

export default component.exports